import { useState, useEffect } from "react";
import {asyncSetter} from "../labelSheet/network/GetFeatureStatusAPI";

export const useFeatures = (featureList) => {
    const [[valid, featureStatusMap], setFeatureStatusMapState] = useState([false, {}]);
    useEffect(() => {
        asyncSetter({featureList}, setFeatureStatusMapState);
    }, [JSON.stringify(featureList)]);
    return [valid, featureStatusMap];
};


// WEBPACK FOOTER //
// ./src/components/handler/DynamicConfigHandler.js